const TutorSelectMixin = {
    data() {
        return {
            tutor_search: "",
            tutors:[],
            old_tutor:null
        }
    },
    watch: {
        "tutor_search"() {
            this.getTutors()
        },
    },
    methods: {
        getTutors() {
            axios.get(apiRoutes.tutors.url, {
                params: {
                    q: this.tutor_search
                }
            }).then(response => {
                console.log(response)
                this.tutors = response.data.response.map(tutor => {
                    return {
                        text: tutor.tutor_fname +" "+ tutor.tutor_lname,
                        value: tutor.tutor_id,
                        fare:tutor.tutor_per_hour_rate
                    }
                })
                if(this.old_tutor!==null){
                    if(this.tutors.findIndex(item=>item.value===this.old_tutor.value)===-1){
                        this.tutors=[this.old_tutor,...this.tutors]
                    }
                }
            })
        }
    }
}
export default TutorSelectMixin